import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

export const isBulkProduct = (productNumber: string) => {
    return productNumber.toLowerCase().endsWith("b");
};

export const productNotAvailable = (product: ProductModel, productInfo: ProductInfo) => {
    if (product.isDiscontinued) {
        const minimumOrderQty = product.minimumOrderQty || 0;
        const qtyOnHand = productInfo.inventory?.qtyOnHand || 0;

        if (qtyOnHand === 0 || qtyOnHand < minimumOrderQty) {
            return true;
        }
    }

    return false;
};

export const completeProductUrl = (urlPath?: string | "") => {
    return urlPath ? `/Product/${urlPath}` : "";
};

export const extPrice = (breakQty: number, breakPrice: number) => {
    const rawPrice = breakQty * breakPrice;
    return Math.round((rawPrice + Number.EPSILON) * 100) / 100;
};
